/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { Grid } from "@mui/material";
import Shell from "../../../common/components/Shell/Shell";
import DependentsPresenter from "./DependentsPresenter";
import DTODependents from "./DTODependents";
import { useAppSelector } from "../../../infra/hooks";
import { useTranslation } from "react-i18next";
function DependentsController() {
  const { t, i18n } = useTranslation();
  const [DepData, setDepData] = useState([]);

  const isLoading = useAppSelector(
    (state) => state.dependentslistSlice.dependentListLoader
  );
  
  function callBackFunc(data: any) {
    setDepData(data);
  }

  return (
    <Shell>
      <DTODependents setDependentsData={callBackFunc} />
      <Grid
        container
        style={{
          marginLeft: "7.25em",
        }}
      >
        <Grid item lg={12} xs={12} sm={12}>
          <DependentsPresenter
            allDependentList={DepData}
            isLoading={isLoading}
            trans={t}
            i18n={i18n}
          />
        </Grid>
      </Grid>
    </Shell>
  );
}
export default DependentsController;
